// extracted by mini-css-extract-plugin
export default {"card":"card_card__1kpsW","currentcard":"card_currentcard__CL2Fo","content":"card_content__VPto0","name":"card_name__BOxQI","img":"card_img__VuIFf","names":"card_names__+EkbF"};